import React, { ReactNode } from "react";

import cn from "classnames";

import styles from "./ButtonGroupButton.module.scss";

export interface ButtonGroupButtonProps<V extends string> {
  className?: string;
  icon: ReactNode;
  title: ReactNode;
  value: V;
}

export interface PrivateButtonGroupButtonProps<V extends string> {
  disabled?: boolean;
  onClick?: (value: V) => void;
  selected?: boolean;
}

interface Props<V extends string>
  extends PrivateButtonGroupButtonProps<V>,
    ButtonGroupButtonProps<V> {}

const ButtonGroupButton = <T extends string>({
  className,
  disabled,
  icon,
  onClick,
  selected,
  title,
  value,
}: Props<T>) => {
  return (
    <div
      className={cn(
        styles.container,
        {
          [styles.disabled]: disabled && !selected,
          [styles.selected]: selected,
        },
        className
      )}
      onClick={() => !disabled && onClick?.(value)}
    >
      <div className={styles.content}>
        {icon}
        <p className={styles.title}>{title}</p>
      </div>
    </div>
  );
};

export default ButtonGroupButton;
